/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, Component, useState } from "react";
import { Slide, TextField } from "@material-ui/core";
import { People, Flag, Place, Add, Remove } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { Grid } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import * as moment from "moment-jalaali";
import { injectIntl } from "react-intl";
import * as homepage from "../../../_redux/homepageRedux";
import { connect, shallowEqual, useDispatch, useSelector } from "react-redux";
import { get_townships } from "../../../_redux/homepageCrud";
import { Radio } from "@material-ui/core";
import { RadioGroup } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { Calendar } from "react-modern-calendar-datepicker";
import { Icon } from "@material-ui/core";
import { loadCSS } from "fg-loadcss";
import { Loop } from "@material-ui/icons";
import "./../widget.css";
// import EbusFilterForms from "./components/forms";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";
import SearchSectionForms from "./SearchSectionForms";
import { Dialog } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import HeaderSearch from "./HeaderSearch";

function SearchSectionSearchWidget(props) {
  const { state } = useSelector(
    (state) => ({
      state: state.homepage,
    }),
    shallowEqual
  );

  const history = useHistory();
  const dispatch = useDispatch();

  const [location, setLocation] = useState(
    history.location.pathname.split("/")
  );
  const [bgImgId, setBgImgId] = React.useState("contents-container");

  React.useEffect(() => {
    if (location[1] === "bus-ticket") {
      setBgImgId("bus-container");
    } else if (location[1] === "") {
      setBgImgId("contents-container");
    }
  });

  if (props.date2 != null && state.initiated == false) {
    props.handle_variables("round_trip", 1);
    let d = moment(props.date, "YYYY-M-D").format("jYYYY-jM-jD");
    d = d.split("-");
    let d2 = moment(props.date2, "YYYY-M-D").format("jYYYY-jM-jD");
    d2 = d2.split("-");

    let round_trip_range = {
      from: {
        year: parseInt(d[0]),
        month: parseInt(d[1]),
        day: parseInt(d[2]),
      },
      to: {
        year: parseInt(d2[0]),
        month: parseInt(d2[1]),
        day: parseInt(d2[2]),
      },
    };
    props.handle_variables("round_trip_range", round_trip_range);
    props.handle_variables("initiated", true);
  }
  function openPassengersPanel() {
    props.change_backPanel(true);
    props.change_passenger_panel(true);
  }
  function closePassengersPanel() {
    props.change_passenger_panel(false);
  }

  function backPlan_onclick() {
    props.change_backPanel(false);
    props.change_passenger_panel(false);
  }

  let handleChanges = (name, data, type) => {
    props.handle_variables(name, data);
  };

  function getSelectedItem(suggestions, value) {
    const item = suggestions.find((opt) => {
      if (parseInt(opt.value) === parseInt(value)) return opt;
    });
    return item || null;
  }

  let suggestions = state.townships.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.title,
  }));

  // if (state.is_form_ready === false) {
  //   get_townships()
  //     .then((data) => {
  //       props.loadTownships(data.data.data);
  //     })
  //     .catch((error) => {
  //       props.loadTownships([]);
  //     });
  // } else {
  //   if (props.source_id !== undefined && state.source_id === null) {
  //     let source = getSelectedItem(suggestions, props.source_id);
  //     if (source !== null) handleChanges("source_id", source, "autocomplete");
  //   }
  //   if (props.dest_id !== undefined && state.dest_id === null) {
  //     let dest = getSelectedItem(suggestions, props.dest_id);
  //     if (dest !== null) handleChanges("dest_id", dest, "autocomplete");
  //   }
  //   if (props.date !== undefined && state.departure_datetime === null) {
  //     let d = moment(props.date, "YYYY-M-D").format("jYYYY-jM-jD");
  //     d = d.split("-");
  //     datepicker_value = {
  //       year: parseInt(d[0]),
  //       month: parseInt(d[1]),
  //       day: parseInt(d[2]),
  //     };
  //     handleChanges("departure_datetime", datepicker_value, "datepicker");
  //   }
  // }

  let datepicker_value = state.departure_datetime;
  if (datepicker_value === null) {
    if (props.date !== undefined) {
      let d = moment(props.date, "YYYY-M-D").format("jYYYY-jM-jD");
      d = d.split("-");
      datepicker_value = {
        year: parseInt(d[0]),
        month: parseInt(d[1]),
        day: parseInt(d[2]),
      };
    } else {
      datepicker_value = utils("fa").getToday();
    }
  }

  let search_url = "";
  if (state.source_id !== null && state.dest_id !== null) {
    if (state.round_trip === 0) {
      let d =
        datepicker_value.year +
        "/" +
        datepicker_value.month +
        "/" +
        datepicker_value.day;
      moment.locale("en");
      d = moment(d, "jYYYY/jM/jD").format("YYYY-M-D");
      search_url =
        "/bus-ticket/" +
        d +
        "/" +
        state.adult_count +
        "," +
        state.child_count +
        "/" +
        state.source_id.value +
        "/" +
        state.dest_id.value;
    } else {
      if (
        state.round_trip_range.from !== null &&
        state.round_trip_range.to !== null
      ) {
        let d1 =
          state.round_trip_range.from.year +
          "/" +
          state.round_trip_range.from.month +
          "/" +
          state.round_trip_range.from.day;
        let d2 =
          state.round_trip_range.to.year +
          "/" +
          state.round_trip_range.to.month +
          "/" +
          state.round_trip_range.to.day;
        moment.locale("en");
        d1 = moment(d1, "jYYYY/jM/jD").format("YYYY-M-D");
        d2 = moment(d2, "jYYYY/jM/jD").format("YYYY-M-D");
        search_url =
          "/bus-ticket/" +
          d1 +
          "," +
          d2 +
          "/" +
          state.adult_count +
          "," +
          state.child_count +
          "/" +
          state.source_id.value +
          "/" +
          state.dest_id.value;
      }
    }
  }

  let round_trip_dates =
    (state.round_trip_range.from === null
      ? ""
      : state.round_trip_range.from.year +
      "/" +
      state.round_trip_range.from.month +
      "/" +
      state.round_trip_range.from.day) +
    " - " +
    (state.round_trip_range.to === null
      ? ""
      : state.round_trip_range.to.year +
      "/" +
      state.round_trip_range.to.month +
      "/" +
      state.round_trip_range.to.day);
  if (round_trip_dates === " - ") round_trip_dates = "";

  const [modalOpen, setModalOpen] = React.useState(false);

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  return (
    <>
      {isMobile ? (
        <Dialog
          fullScreen={true}
          open={state.mobileDialogOpen}
          PaperProps={{ style: { borderRadius: "0px" } }}
        >
          <div>
            <div className="d-flex justify-content-start container py-2">
              <i
                className="fa fa-times ebus-primary-color font-20"
                onClick={() => {
                  dispatch(homepage.actions.setMobileDialog(false));
                }}
              ></i>
            </div>
            <SearchSectionForms
              source_id={props.source_id}
              dest_id={props.dest_id}
              date={props.date}
              date2={props.date2}
              count={props.count}
              className="gutter-b"
              widgetHeight="150px"
            />
          </div>
        </Dialog>
      ) : (
        <div
          id={bgImgId}
          className="row justify-content-center p-5"
          style={{
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 82%",
          }}
        >
          <HeaderSearch />
          <SearchSectionForms
            source_id={props.source_id}
            dest_id={props.dest_id}
            date={props.date}
            date2={props.date2}
            count={props.count}
            className="gutter-b"
            widgetHeight="150px"
          />
        </div>
      )}
    </>
  );
}

export default injectIntl(
  connect(null, homepage.actions)(SearchSectionSearchWidget)
);
